import {IClassNameProps} from '@bem-react/core';
import React, {useState} from 'react';
import './FacadeMaterials.css';
import {cnFacadeMaterials} from "./index";
import {TObjectSelectListType} from '../../../types/TObjectSelectListType';
import {IFacadeMaterialData} from '../../../../common-code/interfaces/materials/IFacadeMaterialData';
import {IFacadeData} from '../../../../common-code/interfaces/materials/IFacadeData';
import {KitchenService} from '../../../3d/services/KitchenService/KitchenService';
import {useTranslation} from 'react-i18next';
import {FacadeMaterialsChangeGroup} from './ChangeGroup/FacadeMaterials-ChangeGroup';
import {ObjectSelectItem} from '../../components/ObjectSelectItem/ObjectSelectItem';
import {IMaterialData} from '../../../../common-code/interfaces/materials/IMaterialData';
import {useSelector} from 'react-redux';
import {AppState} from '../../../redux/AppStore';
import {filterFacadeList, filterFacadeMaterialList} from '../../../helpers';
import {ICreateObjectData} from '../../../../common-code/interfaces/createData/ICreateObjectData';
import {TLevel} from '../../../../common-code/types/TLevel';

export interface IFacadeMaterialsProps extends IClassNameProps {
    type?: TObjectSelectListType;
    listMaterialData?: IFacadeMaterialData[];
    materialData?: IFacadeMaterialData;
    listFacadeData?: IFacadeData[];
    title?: string;
    onSelectObject?: (objectData: IFacadeMaterialData) => void;
    service?: KitchenService;
    createUnit?: ICreateObjectData;
    level?: TLevel;
}

export const FacadeMaterials: React.FC<IFacadeMaterialsProps> =
    ({
         className,
         listMaterialData,
         materialData,
         listFacadeData,
         title,
         onSelectObject,
         service,
         createUnit,
         level
     }) => {
        const {t} = useTranslation();
        const allMaterials: IMaterialData[] | undefined = useSelector((state: AppState) => state.wizard.materials);
        const [activeFacadeGroup, setActiveFacadeGroup] = useState<string | boolean>(materialData ? materialData.facade : false);

        const openFacadeMaterials = (id: string) => {
            setActiveFacadeGroup(id);
        }

        const closeFacadeGroup = () => {
            setActiveFacadeGroup(false);
        }

        const getFacadeMaterialImage = (
            facadeMaterial: IFacadeMaterialData,
            allMaterials?: IMaterialData[]
        ): string | undefined => {
            if (allMaterials && (!facadeMaterial.image || !facadeMaterial.image.length)) {
                let material: IMaterialData;
                for (material of allMaterials) {
                    if (material.id === facadeMaterial.material) {
                        return material.image;
                    }
                }
            }

            return facadeMaterial.image;
        }

        const getFacadeMaterialColor = (
            facadeMaterial: IFacadeMaterialData,
            allMaterials?: IMaterialData[]
        ): string | undefined => {
            if (allMaterials) {
                let material: IMaterialData;
                for (material of allMaterials) {
                    if (material.id === facadeMaterial.material) {
                        return material.color;
                    }
                }
            }

            return undefined;
        }

        if (!service) {
            return null;
        }

        return (
            <div className={cnFacadeMaterials({}, [className])}>
                <div className={cnFacadeMaterials('Header')}>
                    <div className={cnFacadeMaterials('Title')}>{`${t('Выберите')} ${title?.toLowerCase()}`}</div>
                    {!materialData || <FacadeMaterialsChangeGroup active={activeFacadeGroup !== false} openFacades={closeFacadeGroup}/>}
                </div>
                <div className={cnFacadeMaterials('Body')}>
                    <div className={cnFacadeMaterials('Items')}>
                        {
                            !activeFacadeGroup ?
                                filterFacadeList(listFacadeData, createUnit, service)?.map((facade) => {
                                    return (
                                        <ObjectSelectItem
                                            key={facade.id}
                                            className={cnFacadeMaterials('Item')}
                                            prevTitle={t('Коллекция') || undefined}
                                            title={facade.title}
                                            image={facade.image}
                                            color={facade.color}
                                            active={facade.id === materialData?.facade}
                                            callBack={() => {
                                                openFacadeMaterials(facade.id);
                                            }}
                                        />
                                    );
                                })
                                :
                                filterFacadeMaterialList(
                                    (typeof activeFacadeGroup === 'string' ? activeFacadeGroup : undefined),
                                    listMaterialData,
                                    createUnit,
                                    service,
                                    level
                                )?.filter(material => material.facade === activeFacadeGroup)
                                    .map((material) => {
                                        if (material.disable) {
                                            return null;
                                        }
                                        if (material.isCustom && material.canChange === false) {
                                            return null;
                                        }
                                        return (
                                            <ObjectSelectItem
                                                key={material.id}
                                                className={cnFacadeMaterials('Item')}
                                                title={material.title}
                                                image={getFacadeMaterialImage(material, allMaterials)}
                                                color={getFacadeMaterialColor(material, allMaterials)}
                                                active={material.id === materialData?.id}
                                                callBack={() => {
                                                    if (onSelectObject) {
                                                        onSelectObject(material);
                                                    }
                                                }}
                                            />
                                        );
                                    })
                        }
                    </div>
                </div>
            </div>
        );
    }